import { getUid as x } from "./watson.es42.js";
import y from "./watson.WIcon.es.js";
import E from "./watson.WStack.es.js";
import S from "./watson.WStackItem.es.js";
import { TOAST_TARGET as b, TOAST_VARIANT_DEFAULT as C, TOAST_TIME_OUT as O } from "./watson.es85.js";
import { resolveComponent as m, openBlock as a, createBlock as n, Teleport as W, createVNode as i, TransitionGroup as T, withCtx as o, createElementBlock as I, Fragment as N, renderList as V, normalizeClass as h, createCommentVNode as w, createElementVNode as k, toDisplayString as $ } from "vue";
import "./watson.WToast.es2.js";
import v from "./watson.es37.js";
const B = {
  name: "WToast",
  components: { WIcon: y, WStack: E, WStackItem: S },
  props: {
    /**
     * Array of objects. The required properties is `content`.
     * @default []
     * @values [ { leadingIcon: String, content: String, variant: String (default, error), timeOut: Number } ]
     * */
    toasts: {
      type: Array,
      default: () => []
    },
    /**
     * Type string or an actual DOM node where you want render component
     * @default body
     */
    target: {
      type: [String, Object],
      default: b,
      required: !1,
      validator: (t) => typeof t == "string" || t instanceof HTMLElement
    }
  },
  emits: ["dismiss"],
  data() {
    return {
      toastsArr: []
    };
  },
  watch: {
    toasts: {
      handler(t) {
        t && this.setToasts();
      },
      deep: !0
    }
  },
  created() {
    this.setToasts();
  },
  methods: {
    setToasts() {
      let t = 0;
      this.toasts.forEach((s) => {
        const e = this.createToast(s);
        setTimeout(
          this.dismiss,
          e.timeOut,
          e.id,
          t
        ), this.addToast(e, t), t += 1;
      });
    },
    addToast(t, s) {
      setTimeout(() => {
        this.toastsArr.push(t);
      }, 500 * s);
    },
    removeToast(t, s) {
      setTimeout(() => {
        const e = this.toastsArr.findIndex((r) => r.id === t);
        this.toastsArr.splice(e, 1);
      }, 500 * s);
    },
    createToast({
      leadingIcon: t,
      content: s,
      variant: e = C,
      timeOut: r = O
    }) {
      return {
        id: x(),
        leadingIcon: t,
        content: s,
        variant: e,
        timeOut: r
      };
    },
    dismiss(t, s) {
      this.removeToast(t, s), this.$emit("dismiss", !0);
    }
  }
}, L = { class: "w-toast-item-title" }, U = ["onClick"];
function D(t, s, e, r, c, A) {
  const l = m("w-icon"), d = m("w-stack-item"), u = m("w-stack");
  return a(), n(W, { to: e.target }, [
    i(T, { name: "w-toast-slide-from-bottom" }, {
      default: o(() => [
        c.toastsArr.length ? (a(), n(u, {
          key: 0,
          class: "w-toast",
          direction: "column",
          gap: "small"
        }, {
          default: o(() => [
            i(T, { name: "w-toast-slide-from-bottom" }, {
              default: o(() => [
                (a(!0), I(N, null, V(c.toastsArr, ({ id: _, leadingIcon: f, content: g, variant: p }) => (a(), n(u, {
                  key: _,
                  class: h(["w-toast-item", `w-toast-item-${p}`]),
                  "full-width": "",
                  gap: "small"
                }, {
                  default: o(() => [
                    i(d, {
                      class: "w-toast-item-content",
                      flex: "auto"
                    }, {
                      default: o(() => [
                        f ? (a(), n(l, {
                          key: 0,
                          class: "w-toast-item-icon",
                          name: f
                        }, null, 8, ["name"])) : w("", !0),
                        k("span", L, $(g), 1)
                      ]),
                      _: 2
                    }, 1024),
                    i(d, {
                      class: "w-toast-item-dismiss",
                      flex: "none"
                    }, {
                      default: o(() => [
                        k("button", {
                          class: h([
                            "w-toast-button-dismiss",
                            `w-toast-button-dismiss-${p}`
                          ]),
                          onClick: (F) => A.dismiss(_)
                        }, [
                          i(l, { name: "close" })
                        ], 10, U)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : w("", !0)
      ]),
      _: 1
    })
  ], 8, ["to"]);
}
const K = /* @__PURE__ */ v(B, [["render", D]]);
export {
  K as default
};
